export type StatusFilter = 'all' | 'pending' | 'verified' | 'rejected';

/** The status chip lives in `?status=`, so the detail screen's back link can restore it. */
export function parseStatus(value: string | null): StatusFilter {
  return value === 'pending' || value === 'verified' || value === 'rejected' ? value : 'all';
}
